import { useState } from 'react'
import { useRevealClass } from '../../../hooks/useRevealClass'
import RemedyModal from './RemedyModal'
import './DivineShopSection.css'
import rudrakshImg from '../../../assets/images/rudraksh.jpg'
import { appUrl } from '@astro/config'
const CATEGORY_TAGS = ['💎 Gemstones', '📿 Yantras', '🌿 Rudraksha', '🔥 Puja Samagri']

const STATS = [
  { value: '50K+', label: 'Shipped' },
  { value: '500+', label: 'Products' },
  { value: '100%', label: 'Certified' },
  { value: '✓', label: 'Blessed' },
]

export default function DivineShopSection() {
  const [modalOpen, setModalOpen] = useState(false)
  const leftReveal = useRevealClass()
  const rightReveal = useRevealClass()

  return (
    <section
      id="divine-shop"
      className="relative overflow-hidden"
      style={{ background: 'radial-gradient(ellipse 120% 100% at 70% 45%,#C2710C 0%,#92400E 28%,#4A1A05 60%,#1A0803 100%)' }}
    >
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        <div style={{ position: 'absolute', top: '-12%', left: '-8%', width: '54vw', height: '54vw', background: 'radial-gradient(ellipse,rgba(229,168,32,.22) 0%,transparent 68%)', borderRadius: '50%', animation: 'gs-orb 18s ease-in-out infinite' }} />
        <div style={{ position: 'absolute', bottom: '-10%', right: '-6%', width: '46vw', height: '46vw', background: 'radial-gradient(ellipse,rgba(194,113,12,.18) 0%,transparent 68%)', borderRadius: '50%', animation: 'gs-orb 22s ease-in-out infinite reverse' }} />
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle,rgba(229,168,32,.07) 1px,transparent 1px)', backgroundSize: '32px 32px' }} />
        <div style={{ position: 'absolute', top: '24px', left: '24px', width: '48px', height: '48px', borderTop: '1.5px solid rgba(229,168,32,.42)', borderLeft: '1.5px solid rgba(229,168,32,.42)', borderRadius: '5px 0 0 0' }} />
        <div style={{ position: 'absolute', top: '24px', right: '24px', width: '48px', height: '48px', borderTop: '1.5px solid rgba(229,168,32,.42)', borderRight: '1.5px solid rgba(229,168,32,.42)', borderRadius: '0 5px 0 0' }} />
        <div style={{ position: 'absolute', bottom: '24px', left: '24px', width: '48px', height: '48px', borderBottom: '1.5px solid rgba(229,168,32,.42)', borderLeft: '1.5px solid rgba(229,168,32,.42)', borderRadius: '0 0 0 5px' }} />
        <div style={{ position: 'absolute', bottom: '24px', right: '24px', width: '48px', height: '48px', borderBottom: '1.5px solid rgba(229,168,32,.42)', borderRight: '1.5px solid rgba(229,168,32,.42)', borderRadius: '0 0 5px 0' }} />
        <div style={{ position: 'absolute', top: '50%', right: '2%', transform: 'translateY(-50%)', fontSize: '260px', lineHeight: 1, opacity: 0.06, userSelect: 'none', fontFamily: 'serif', color: '#E5A820' }}>
          ॐ
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12" style={{ paddingTop: '64px', paddingBottom: '64px' }}>
        <div className="flex items-center justify-center gap-4 mb-8">
          <div style={{ height: '1px', flex: 1, maxWidth: '64px', background: 'linear-gradient(90deg,transparent,rgba(229,168,32,.55))' }} />
          <span style={{ fontSize: '9px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.3em', color: 'rgba(229,168,32,.9)' }}>
            Divine Shop
          </span>
          <div style={{ height: '1px', flex: 1, maxWidth: '64px', background: 'linear-gradient(90deg,rgba(229,168,32,.55),transparent)' }} />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-6 items-center">
          <div
            ref={leftReveal.ref}
            className={`lg:col-span-6 gs-reveal text-center lg:text-left${leftReveal.visible ? ' gs-visible' : ''}`}
          >
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '5px 14px', borderRadius: '999px', background: 'rgba(229,168,32,.14)', border: '1px solid rgba(229,168,32,.35)', marginBottom: '12px' }}>
              <span style={{ fontSize: '10px' }}>🏷️</span>
              <span style={{ fontSize: '8px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.22em', color: 'rgba(255,215,110,.9)' }}>
                Gems & Remedies Store
              </span>
            </div>

            <h2 className="font-royal font-normal mb-4" style={{ fontSize: 'clamp(30px,3.8vw,52px)', lineHeight: 1.06, color: '#FEFCF8' }}>
              GEMSTONES &amp;
              <br />
              <span style={{ background: 'linear-gradient(135deg,#FFD87A 0%,#F5A623 45%,#FFD87A 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                REMEDIES
              </span>
            </h2>

            <p className="font-body mb-5 mx-auto lg:mx-0" style={{ fontSize: '13.5px', lineHeight: 1.68, color: 'rgba(255,225,165,.78)', maxWidth: '420px' }}>
              Genuine, lab-certified gemstones, cosmic Yantras, authentic Rudraksha malas and custom puja items — each carefully
              energised and blessed by Maharaj Ji to align your planetary matrix.
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-1.5 mb-4">
              {CATEGORY_TAGS.map((tag) => (
                <span key={tag} className="gs-feat-tag" style={{ padding: '4px 11px', fontSize: '8px', background: 'rgba(255,255,255,.07)', color: 'rgba(255,220,150,.85)', border: '1px solid rgba(229,168,32,.28)' }}>
                  {tag}
                </span>
              ))}
            </div>

            <div
              className="flex items-stretch justify-center lg:justify-start overflow-x-auto no-scrollbar mb-5"
              style={{ border: '1px solid rgba(229,168,32,.3)', borderRadius: '14px', background: 'rgba(255,255,255,.06)', backdropFilter: 'blur(12px)', boxShadow: '0 3px 20px rgba(0,0,0,.3)', width: 'fit-content', maxWidth: '100%' }}
            >
              {STATS.map((stat, i) => (
                <div className="flex items-stretch" key={stat.label}>
                  {i > 0 && <div style={{ width: '1px', background: 'rgba(229,168,32,.25)', margin: '8px 0' }} />}
                  <div className="text-center px-4 py-3" style={{ minWidth: '68px' }}>
                    <div style={{ fontFamily: 'var(--font-heading),serif', fontSize: '21px', fontWeight: 700, lineHeight: 1, background: 'linear-gradient(135deg,#FFD87A,#F5A623)', WebkitBackgroundClip: 'text', backgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                      {stat.value}
                    </div>
                    <div style={{ fontSize: '7px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.15em', color: 'rgba(255,210,120,.6)', marginTop: '2px', whiteSpace: 'nowrap' }}>
                      {stat.label}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href={appUrl('shop', "products")}
                className="gs-cta-btn" style={{ fontSize: '9px', padding: '11px 26px', background: 'linear-gradient(135deg,#E5A820,#FFD87A)', color: '#1A0803' }}
              >
                Explore Shop
                <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                </svg>
              </a>

              {/* <button type="button" className="gs-ghost-btn" style={{ fontSize: '9px', padding: '9px 18px', color: 'rgba(255,220,140,.9)', border: '1.5px solid rgba(229,168,32,.4)' }} onClick={() => setModalOpen(true)}>
                Get Recommendation
                <svg width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m19 9-7 7-7-7" />
                </svg>
              </button> */}
              <a
                href={appUrl('jyotish', "consultations")}
                className="gs-ghost-btn"
                style={{ fontSize: '9px', padding: '9px 18px', color: 'rgba(255,220,140,.9)', border: '1.5px solid rgba(229,168,32,.4)' }}
              >
                Get Recommendation
                <svg width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m19 9-7 7-7-7" />
                </svg>
              </a>
            </div>
          </div>

          <div
            ref={rightReveal.ref}
            className={`lg:col-span-6 gs-reveal flex items-center justify-center${rightReveal.visible ? ' gs-visible' : ''}`}
            style={{ transitionDelay: '.12s' }}
          >
            <div style={{ position: 'relative', width: '100%', maxWidth: '490px', aspectRatio: '1', margin: '0 auto' }}>
              <div className="gs-ring gs-ring-1" style={{ borderColor: 'rgb(255 255 255 / 35%)' }} />
              <div className="gs-ring gs-ring-2" style={{ borderColor: 'rgb(246 145 43 / 65%)' }} />
              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: '72%', height: '72%', background: 'radial-gradient(ellipse,rgba(229,168,32,.22) 0%,transparent 72%)', borderRadius: '50%', pointerEvents: 'none' }} />

              <ShopImageFrame />

              <div style={{ position: 'absolute', top: '7%', right: '4%', width: '36px', height: '36px', borderRadius: '50%', background: 'linear-gradient(135deg,#FFD87A,#E5A820)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', boxShadow: '0 4px 18px rgba(229,168,32,.6)', animation: 'gs-float 5s ease-in-out infinite .7s', zIndex: 10 }}>
                ♄
              </div>
              <div style={{ position: 'absolute', bottom: '10%', left: '1%', width: '30px', height: '30px', borderRadius: '50%', background: 'linear-gradient(135deg,#6B46CE,#9B59B6)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', boxShadow: '0 3px 14px rgba(107,70,206,.55)', animation: 'gs-float 6s ease-in-out infinite 1.5s', zIndex: 10 }}>
                🔮
              </div>
              <div style={{ position: 'absolute', top: '48%', right: '-1%', transform: 'translateY(-50%)', width: '26px', height: '26px', borderRadius: '50%', background: 'linear-gradient(135deg,#E74C3C,#C0392B)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', boxShadow: '0 3px 13px rgba(231,76,60,.55)', animation: 'gs-float 4.5s ease-in-out infinite 2.2s', zIndex: 10 }}>
                ✦
              </div>
            </div>
          </div>
        </div>
      </div>

      <RemedyModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </section>
  )
}

function ShopImageFrame() {
  const [imgFailed, setImgFailed] = useState(false)

  return (
    <div
      className="group"
      style={{
        position: 'absolute',
        inset: '7%',
        borderRadius: '2rem',
        overflow: 'hidden',
        border: '1.5px solid rgba(229,168,32,.45)',
        boxShadow: '0 24px 64px rgba(0,0,0,.55),0 0 40px rgba(194,113,12,.25),inset 0 1px 0 rgba(255,255,255,.2)',
        animation: 'gs-float 7s ease-in-out infinite',
        background: '#1A0803',
      }}
    >
      <div style={{ position: 'absolute', inset: 0, zIndex: 1, backgroundImage: 'radial-gradient(circle,rgba(229,168,32,.09) 1.5px,transparent 1.5px)', backgroundSize: '20px 20px', pointerEvents: 'none' }} />
      {!imgFailed && (
        <img
          src={rudrakshImg}
          alt="Vedic Gemstones and Sacred Remedies"
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', transition: 'transform 1.1s cubic-bezier(.16,1,.3,1)', zIndex: 2 }}
          className="group-hover:scale-105"
          onError={() => setImgFailed(true)}
        />
      )}
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '38%', background: 'linear-gradient(to top,rgba(26,8,3,.82),transparent)', zIndex: 3 }} />
      <div style={{ position: 'absolute', bottom: '14px', left: '50%', transform: 'translateX(-50%)', zIndex: 5, whiteSpace: 'nowrap' }}>
        <div style={{ background: 'rgba(26,8,3,.75)', backdropFilter: 'blur(12px)', border: '1px solid rgba(229,168,32,.4)', borderRadius: '999px', padding: '5px 15px', boxShadow: '0 3px 13px rgba(0,0,0,.3)' }}>
          <span style={{ fontFamily: 'var(--font-heading),serif', fontSize: '8px', fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD87A' }}>
            ✦ Energised &amp; Vedic Blessed ✦
          </span>
        </div>
      </div>
    </div>
  )
}
